import React from 'react'
import Index from '../../components/index';

function Home() {
  return (
  <Index/>
  )
}

export default Home
